import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    copyProjectUrl: string;
    delete: string;
    duplicate: string;
    manageMembers: string;
    markActive: string;
    markInactive: string;
    newCollection: string;
    newFolder: string;
    newFolderAriaLabel: string;
    notifications: string;
    projectSettings: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the option to copy the current project's URL in the Project Menu */
            copyProjectUrl: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.copyProjectUrl?c=3c8djzli68xet", defaultMessage: "Copy Project URL" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the delete option for Project Menu */
            delete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.delete?c=7nzkz7owpk0x", defaultMessage: "Delete" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the duplicate option for Project Menu */
            duplicate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.duplicate?c=gwcnintdwpnx", defaultMessage: "Duplicate" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the manage members option for Project Menu */
            manageMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.manageMembers?c=tklamxbrwz1l", defaultMessage: "Manage Members" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the option to mark a project as active in the Project Menu */
            markActive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.markActive?c=1onj2x0360y5w", defaultMessage: "Mark Active" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the option to mark a project as inactive in the Project Menu */
            markInactive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.markInactive?c=g8933be523v9", defaultMessage: "Mark Inactive" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the option to create a new collection in the Project Menu */
            newCollection: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.newCollection?c=3s1e90rdyp5qt", defaultMessage: "New Collection" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the option to create a new folder in the Project Menu */
            newFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.newFolder?c=hz1l49khdeht", defaultMessage: "New Folder" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the option to create a new folder in the Project Menu */
            newFolderAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.newFolderAriaLabel?c=1heqqhz3g102c", defaultMessage: "New Folder submenu" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the option to toggle notifications in the Project Menu */
            notifications: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.notifications?c=1bmhy5j8pv1g6", defaultMessage: "Notifications" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the project settings option for Project Menu */
            projectSettings: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectMenu.projectSettings?c=2okd1owibl5lb", defaultMessage: "Project Settings" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
